import React, { useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import classNames from 'classnames';
import {
  Dropdown,
  Option,
  Label,
  FluentProvider,
  webLightTheme,
} from '@fluentui/react-components';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { getAdStatuStyles } from './style';

const adStatusOptions = [
  {
    textKey: _TL_('Active'),
    value: 'Active',
  },
  {
    textKey: _TL_('Paused'),
    value: 'Paused',
  },
];

const dropdownId = 'responsiveAdStatusLabel';

export const AdStatus = ({ onAdStatusChange, data: value }) => {
  const i18n = useContext(I18nContext);
  const classes = useDefaultStyles(getAdStatuStyles);

  const handleStatusChange = useCallback(
    (e, data) => {
      onAdStatusChange(data.optionValue);
    },
    [onAdStatusChange]
  );

  const currentValue = value || 'Active';
  const currentText = i18n.getString(_.find(adStatusOptions, option => option.value === currentValue).textKey);

  return (
    <FluentProvider theme={webLightTheme}>
      <div className="ad-status">
        <div>
          <Label id={dropdownId}>{i18n.getString(_TL_('Ad status'))}</Label>
        </div>
        <Dropdown
          aria-labelledby={dropdownId}
          onOptionSelect={handleStatusChange}
          value={currentText}
          selectedOptions={[currentValue]}
          className={classes.dropdown}
        >
          {adStatusOptions.map(option => (
            <Option key={option.value} value={option.value} className={classNames(option.value === value ? classes.selectedOption : '', classes.option)}>
              {i18n.getString(option.textKey)}
            </Option>
          ))}
        </Dropdown>
      </div>
    </FluentProvider>
  );
};

AdStatus.propTypes = {
  onAdStatusChange: PropTypes.func.isRequired,
  data: PropTypes.string.isRequired,
};
